class Storage {
    getLocalRefreshToken() {
        return localStorage.getItem("refreshToken");
    }
    getLocalAccessToken() {
        return localStorage.getItem("accessToken");
    }
    getLocalAppToken() {
        return localStorage.getItem("appToken");
    }
    getLocalMode() {
        let mode = localStorage.getItem("mode");
        if (mode === null) {
            mode = 'light';
            this.updateLocalMode(mode);
        }
        return mode;
    }
    getLocalProfile() {
        return localStorage.getItem("profile");
    }
    updateLocalMode(mode) {
        localStorage.setItem('mode', mode);
    }
    updateLocalAccessToken(accessToken) {
        localStorage.setItem("accessToken", accessToken);
    }
    updateLocalRefreshToken(refreshToken) {
        localStorage.setItem("refreshToken", refreshToken);
    }
    updateLocalAppToken(appToken) {
        localStorage.setItem("appToken", appToken);
    }
    removeAccessToken() {
        localStorage.removeItem("accessToken");
    }
    removeRefreshToken() {
        localStorage.removeItem("refreshToken");
    }
    removeAppToken() {
        localStorage.removeItem("appToken")
    }
    updateLocalProfile(profile) {
        localStorage.setItem("profile", profile);
    }
    removeLocalProfile() {
        localStorage.removeItem("profile");
    }
}
export default new Storage();